import moment from "moment/moment"

export const columnDefsCorporateRateMatrixHistoryTable = [
  {
    headerName: 'S/N', headerSx: { minWidth: '10px' }, field: 'sn', dataType: 'string', showfilter: false, allowSorting: false,
    xlCol: { dataType: 'string', dataFormatter: null }
  },
  {
    headerName: `Party\nName`,
    //headerName: 'Auto Delivery\n By City',
    headerSx: { minWidth: '100px' },
    field: 'partyName',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
    xlCol: { dataType: 'string', dataFormatter: null }
  },
  {
    headerName: 'Party\nID',
    headerSx: { minWidth: '100px' },
    field: 'partyId',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
    xlCol: { dataType: 'string', dataFormatter: null }
  },
  {
    headerName: 'Consign.\nType',
    headerSx: { minWidth: '100px' },
    field: 'consignType',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
    xlCol: { dataType: 'string', dataFormatter: null }
  },
  {
    headerName: 'Consign.\nID',
    headerSx: { minWidth: '100px' },
    field: 'consignId',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
    xlCol: { dataType: 'string', dataFormatter: null }
  },
  {
    headerName: 'Source\nCity',
    headerSx: { minWidth: '100px' },
    field: 'srcCity',
    dataType: 'number',
    showfilter: true,
    allowSorting: false,
    xlCol: { dataType: 'string', dataFormatter: null }
  },
  {
    headerName: 'Source\nCity ID',
    headerSx: { minWidth: '100px' },
    field: 'srcCityId',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
    xlCol: { dataType: 'string', dataFormatter: null }
  },
  {
    headerName: 'Destination\nCity',
    headerSx: { minWidth: '100px' },
    field: 'destCity',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
    xlCol: { dataType: 'string', dataFormatter: null }
  },
  {
    headerName: 'Dest.\nCity ID',
    headerSx: { minWidth: '100px' },
    field: 'destCityId',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
    xlCol: { dataType: 'string', dataFormatter: null }
  },
  {
    headerName: 'Distance\nIn KMS',
    headerSx: { minWidth: '100px' },
    field: 'distance',
    dataType: 'number',
    showfilter: true,
    allowSorting: true,
    xlCol: { dataType: 'number', dataFormatter: null }
  },
  {
    headerName: 'Price\nUnit',
    headerSx: { minWidth: '100px' },
    field: 'price',
    dataType: 'number',
    showfilter: false,
    allowSorting: true,
    xlCol: { dataType: 'number', dataFormatter: null }
  },
  { headerName: 'Rate', headerSx: { minWidth: '50px' }, field: 'rate', dataType: 'number', showfilter: false, allowSorting: false, xlCol: { dataType: 'number', dataFormatter: null } },
  { headerName: 'Modified\nBy', headerSx: { minWidth: '100px' }, field: 'modifyBy', dataType: 'string', showfilter: false, allowSorting: false, xlCol: { dataType: 'string', dataFormatter: null } },
  { headerName: 'Modified Time\n& Date', headerSx: { minWidth: '100px' }, field: 'modifyTime', dataType: 'string', showfilter: false, allowSorting: false, xlCol: { dataType: 'string', dataFormatter: null } },
]
export const paymentWiseColumnsStyles = {
  0: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  1: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  2: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  3: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  4: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  5: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  6: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  7: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  8: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  9: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  10: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  11: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  12: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
  13: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
}
export const paymentWiseDrawCell = function (data) {
  var rows = data.table.body
  rows.map((val) => {
    if (data.row.section === 'head') {
      if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
        data.cell.styles.halign = "right"
      } else {
        data.cell.styles.halign = "left"
      }
    }
    if (val.raw.isSubHeading) {
      val.cells[0].colSpan = 5
      val.cells[0].styles.font = 'Roboto'
      val.cells[0].styles.fontStyle = 'normal'
      val.cells[0].styles.fontSize = '16'
      val.cells[0].styles.textColor = [0, 0, 0]
      val.cells[0].styles.halign = 'left'
      val.cells[0].styles.fillColor = [233, 245, 255]
      val.cells[5].colSpan = 4
      val.cells[5].styles.font = 'Roboto'
      val.cells[5].styles.fontStyle = 'normal'
      val.cells[5].styles.fontSize = '16'
      val.cells[5].styles.textColor = [0, 0, 0]
      val.cells[5].styles.halign = 'left'
      val.cells[5].styles.fillColor = [233, 245, 255]
      val.cells[9].colSpan = 5
      val.cells[9].styles.font = 'Roboto'
      val.cells[9].styles.fontStyle = 'normal'
      val.cells[9].styles.fontSize = '16'
      val.cells[9].styles.textColor = [0, 0, 0]
      val.cells[9].styles.halign = 'right'
      val.cells[9].styles.fillColor = [233, 245, 255]
    }
  })
}
export const lrDetailPdfFooter = (data, userData, totalPagesExp) => {
  const doc = data.doc
  // Footer
  var pageSize = doc.internal.pageSize
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
  var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

  var str = 'Page : ' + doc.internal.getNumberOfPages()
  if (typeof doc.putTotalPages === 'function') {
    str = str + ' of ' + totalPagesExp
  }
  doc.setFontSize(16)
  doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
  doc.setFont('Roboto', 'bold')
  doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
  doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
}
export const pdfHeaderColumn = [
  { headerName: 'Party', exportHead: 'Party', field: 'party', xlCol: { dataType: 'number', dataFormatter: null }, align: "left" },
  { headerName: 'Cargo Service Type', exportHead: 'Cargo Service Type', field: 'cargoserviceType', xlCol: { dataType: 'string', dataFormatter: null }, align: "left" },
  { headerName: 'Multi Cargo Service Type', exportHead: 'Multi Cargo Service Type', field: 'multiCargoserviceType', xlCol: { dataType: 'string', dataFormatter: null }, align: "right" },
  { headerName: 'Consignment Type', exportHead: 'Consignment Type', field: 'cnsgnmentType', xlCol: { dataType: 'string', dataFormatter: null }, align: "right" },
]
export const cargoServiceType = [
  // { id: 0, name: 'All' },
  { id: 0, name: 'Single' },
  { id: 1, name: 'Multiple' },
]
export const multiCargoServiceType = [
  { id: 0, name: 'All' },
  { id: 1, name: 'By Bus' },
  { id: 2, name: 'By Cargo' },
  { id: 3, name: 'By Express Cargo' },
  { id: 4, name: 'By Partner Cargo' },
]
export const corporateRateMatrixTypeDrop = [

  { id: 1, name: 'Per KG' },
  { id: 2, name: 'Per Quantity' },
  { id: 3, name: 'Per LR' },
  { id: 4, name: 'Per KG-KM' },
]
export const fields = [
  { key: 'FreightType', label: 'Freight', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'Freight' },
  { key: 'CollCartageType', label: 'CollCartage', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'CollCartage' },
  { key: 'DelCartageType', label: 'DelCartage', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'DelCartage' },
  { key: 'DocChgType', label: 'DocChg', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'DocChg' },
  { key: 'HamaliChgType', label: 'HamaliChg', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'HamaliChg' },
  { key: 'LaborChgType', label: 'LaborChg', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'LaborChg' },
  { key: 'PickupChgType', label: 'PickupChg', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'PickupChg' },
  { key: 'DropoffChgType', label: 'DropoffChg', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'DropoffChg' },
  { key: 'DocChgType', label: 'DocChg', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'DocChg' },
  { key: 'ValuationType', label: 'ValuationChg', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'ValuationChg' },
  { key: 'ConvChgType', label: 'ConvChg', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'ConvChg' },
  { key: 'DeliveryChgType', label: 'DeliveryChg', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'DeliveryChg' },
  { key: 'DelOpHamaliType', label: 'DelOpHamali', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'DelOpHamali' },
  { key: 'DelCartageOnDelType', label: 'DelCartageOnDel', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'DelCartageOnDel' },
  { key: 'DemurrageType', label: 'Demurrage', options: ['Per KG', 'Per Quantity', 'Per LR', 'Per KG-KM'], valueKey: 'Demurrage' }
];
export const corporateRateHead = [
  // { headerName: 'Service\nID', dropDown: '', field: 'ServiceTypeID', headerSx: { minWidth: "100px" } },
  { headerName: 'Service\nType', dropDown: '', field: 'ServiceType', headerSx: { minWidth: "100px", borderRight: '1px solid rgba(224, 224, 224, 1)' } },
  { headerName: 'Freight\nCharges', dropDown: 'FreightType', headerSx: { minWidth: "120px" }, field: 'Freight' },
  { headerName: 'Collection\nCartage', dropDown: 'CollCartageType', headerSx: { minWidth: "120px" }, field: 'CollCartage' },
  { headerName: 'Del. Cartage\nOn Booking', dropDown: 'DelCartageType', headerSx: { minWidth: "120px" }, field: 'DelCartage' },
  { headerName: 'Document\nCharges', dropDown: 'DocChgType', headerSx: { minWidth: "120px" }, field: 'DocChg' },
  { headerName: 'Hamali\nCharge', dropDown: 'HamaliChgType', headerSx: { minWidth: "120px" }, field: 'HamaliChg' },
  { headerName: 'Opr. Hamali\nCharge', dropDown: 'LaborChgType', headerSx: { minWidth: "120px" }, field: 'LaborChg' },
  { headerName: 'Pickup\nCharge', dropDown: 'PickupChgType', headerSx: { minWidth: "120px" }, field: 'PickupChg' },
  { headerName: 'DropOff\nCharge', dropDown: 'DropoffChgType', headerSx: { minWidth: "120px" }, field: 'DropoffChg' },
  { headerName: 'Valuation\nAmount', dropDown: 'ValuationType', headerSx: { minWidth: "120px" }, field: 'ValuationChg' },
  { headerName: 'Conv.\nFees', dropDown: 'ConvChgType', headerSx: { minWidth: "120px" }, field: 'ConvChg' },
  { headerName: 'Del. Hamali\nCharges', dropDown: 'DeliveryChgType', headerSx: { minWidth: "120px" }, field: 'DeliveryChg' },
  { headerName: 'Delivery Opr.\nHam. Chrgs.', dropDown: 'DelOpHamaliType', headerSx: { minWidth: "120px" }, field: 'DelOpHamali' },
  { headerName: 'Del. Cartage\nOn Delivery', dropDown: 'DelCartageOnDelType', headerSx: { minWidth: "120px" }, field: 'DelCartageOnDel' },
  { headerName: 'Demurrage\nCharges', dropDown: 'DemurrageType', headerSx: { minWidth: "120px" }, field: 'Demurrage' },
]
export const columnDefsCorporateMatric = [
  { headerName: 'Service\nType ', headerSx: { minWidth: '140px' }, field: 'serviceType', dataType: 'string', showfilter: false, allowSorting: false },
  {
    headerName: `Freight\nCharges`,
    //headerName: 'Auto Delivery\n By City',
    headerSx: { minWidth: '150px' },
    field: 'Freight',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
  },
  {
    headerName: 'Collection\nCartage',
    headerSx: { minWidth: '160px' },
    field: 'collection',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
  },
  {
    headerName: 'Del. Cartage\nOn Booking',
    headerSx: { minWidth: '150px' },
    field: 'delCartage',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
  },
  {
    headerName: 'Document\nCharges',
    headerSx: { minWidth: '150px' },
    field: 'documentCharges',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
  },
  {
    headerName: 'Hamali\nCharge',
    headerSx: { minWidth: '150px' },
    field: 'hamali',
    dataType: 'number',
    showfilter: true,
    allowSorting: false,
  },
  {
    headerName: 'Opr. Hamali\nCharge.',
    headerSx: { minWidth: '150px' },
    field: 'oprHamali',
    dataType: 'number',
    showfilter: true,
    allowSorting: false,
  },
  {
    headerName: 'Pickup\nCharge',
    headerSx: { minWidth: '150px' },
    field: 'pickup',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
  },
  {
    headerName: 'Dropoff\nCharge.',
    headerSx: { minWidth: '150px' },
    field: 'dropOff',
    dataType: 'number',
    showfilter: true,
    allowSorting: false,
  },
  {
    headerName: 'Doc.\nCharge',
    headerSx: { minWidth: '150px' },
    field: 'docChrg',
    dataType: 'string',
    showfilter: true,
    allowSorting: true,
  },
  {
    headerName: 'Valuation\nAmount',
    headerSx: { minWidth: '150px' },
    field: 'valuation',
    dataType: 'time',
    showfilter: false,
    allowSorting: true,
  },
  { headerName: 'Conv.\nFees', headerSx: { minWidth: '150px' }, field: 'conFee', dataType: 'string', showfilter: false, allowSorting: false },
  { headerName: 'Del.Hamali\nCharges', headerSx: { minWidth: '150px' }, field: 'delHamaliChrg', dataType: 'string', showfilter: false, allowSorting: false },
  { headerName: 'Delivery Opr\nHam.Chrgs', headerSx: { minWidth: '150px' }, field: 'delOprHamali', dataType: 'string', showfilter: false, allowSorting: false },
  { headerName: 'Del.Cartage\nOn Delivery', headerSx: { minWidth: '150px' }, field: 'delCartage', dataType: 'string', showfilter: false, allowSorting: false },
  { headerName: 'Demurrage\nCharges', headerSx: { minWidth: '150px' }, field: 'demurrage', dataType: 'string', showfilter: false, allowSorting: false },
]
export const formatDateTime = (dateTimeStr) => {
  const date = new Date(dateTimeStr);

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const time = `${hours}:${minutes}`;

  const day = String(date.getDate()).padStart(2, '0');
  const monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthShortNames[date.getMonth()];
  const year = String(date.getFullYear()).slice(-2);

  const formattedDate = `${day}-${month}-${year}`;

  return `${time}, ${formattedDate}`;
};
export const consifnmentHistoryTableColumnDefs = [
  { headerName: 'S/N', headerSx: { minWidth: '10px' }, field: 'sn', dataType: 'string', showfilter: false, allowSorting: false },
  {
    headerName: 'Party\nID',
    headerSx: { minWidth: '100px' },
    field: 'partyId',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
  },
  {
    headerName: `Party\nName`,
    //headerName: 'Auto Delivery\n By City',
    headerSx: { minWidth: '100px' },
    field: 'partyName',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
  },

  {
    headerName: 'Consign.\nID',
    headerSx: { minWidth: '100px' },
    field: 'consignId',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
  },
  {
    headerName: 'Consign.\nType',
    headerSx: { minWidth: '100px' },
    field: 'consignType',
    dataType: 'string',
    showfilter: true,
    allowSorting: false,
  },
  {
    headerName: 'Range\nFrom unit',
    headerSx: { minWidth: '80px' },
    field: 'fromUnit',
    dataType: 'number',
    showfilter: true,
    allowSorting: false,
  },
  {
    headerName: 'Range\nTo unit',
    headerSx: { minWidth: '80px' },
    field: 'toUnit',
    dataType: 'number',
    showfilter: true,
    allowSorting: false,
  },

  { headerName: 'Min. Chrg.\nWeight', headerSx: { minWidth: '50px' }, field: 'minChrgWeight', dataType: 'string', showfilter: false, allowSorting: false },
  { headerName: 'Modified By', headerSx: { minWidth: '100px' }, field: 'modifyBy', dataType: 'string', showfilter: false, allowSorting: false },
  { headerName: 'Modified\nTime & Date', headerSx: { minWidth: '110px' }, field: 'modifyTime', dataType: 'string', showfilter: false, allowSorting: false },
]

export const corporateRateMatrixObj = {
  ServiceTypeID: 0,
  ServiceType: '',
  CollCartage: 0,
  CollCartageType: 0,
  DelCartage: 0,
  DelCartageType: 0,
  DocChg: 0,
  DocChgType: 0,
  ValuationChg: 0,
  ValuationType: 0,
  DeliveryChg: 0,
  DeliveryChgType: 0,
  HamaliChg: 0,
  HamaliChgType: 0,
  LaborChg: 0,
  LaborChgType: 0,
  Freight: 0,
  FreightChgType: 0,
  PickupChg: 0,
  PickupChgType: 0,
  DropoffChg: 0,
  DropoffChgType: 0,
  ConvChg: 0,
  ConvChgType: 0,
  DelOpHamali: 0,
  DelOpHamaliType: 0,
  DelCartageOnDel: 0,
  DelCartageOnDelType: 0,
  Demurrage: 0,
  DemurrageType: 0
}